import { render, staticRenderFns } from "./add-group-dialog.vue?vue&type=template&id=3f7d8711&scoped=true"
import script from "./add-group-dialog.vue?vue&type=script&lang=js"
export * from "./add-group-dialog.vue?vue&type=script&lang=js"
import style0 from "./add-group-dialog.vue?vue&type=style&index=0&id=3f7d8711&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7d8711",
  null
  
)

export default component.exports